// extracted by mini-css-extract-plugin
module.exports = {"iconStyles":"DrawerStyle_iconStyles__G_YvS"};